import React from 'react';

const UnderlineButton = ({
  Icon,
  onClick,
  text,
  variant = 'primary',
  iconSize = 12,
  className = '',
  disabled,
  ref,
  children
}) => {
  return (
    <span
      className={`d-inline-block px-1 text-${disabled ? 'muted' : variant} ${!disabled ? 'hover-light' : ''
        } underline rounded smallFont ${className}`}
      size="sm"
      onClick={() => !disabled && onClick()}
      ref={ref}
    >
      {Icon && <Icon size={iconSize} className="align-middle mr-1" />}
      <span>{text}</span>
      {children}
    </span>
  );
};

export default UnderlineButton;
